var STICKY_HEADER = 'sticky_header';
var EXPERIMENTS_BY_AKAMAI_SEGMENT = {
    '4225e27aea81de0d': STICKY_HEADER,
};
export var getExperiment = function (id) { return EXPERIMENTS_BY_AKAMAI_SEGMENT[id] || null; };
export var isExperimentActive = function (id, experiment) {
    return getExperiment(id) === experiment;
};
export var experiments = { STICKY_HEADER: STICKY_HEADER };
